<template>
    <overlay-scrollbars :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' } }">
        <div class="customer-list">
            <div v-for="customer in customerList" :key="customer.id" @click="selectEmail(customer)">
                <div class="customer-container">
                    <div class="avatar-container">
                        <b-avatar :text="customer.contact_name[0]" />
                    </div>
                    <div class="customer" style="display: inline-block">
                        <div class="customer--name">{{ customer.name }}</div>
                        <div class="customer--email">{{ customer.email }}</div>
                    </div>
                </div>
            </div>
        </div>
    </overlay-scrollbars>
</template>

<script>
import CustomerService from "@/store/services/customer.service";

export default {
    name: "EmailSuggestionTable",
    props: {
        searchText: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            customerList: []
        }
    },
    watch: {
        searchText(newVal) {
            let filters = {
                search_by_email: newVal,
                owner_company: window.company_id
            }
            CustomerService.list(filters).then((response) => {
                this.customerList = response.data;
            });
        }
    },
    methods: {
        selectEmail(customer) {
            this.$emit("emailSelected", customer);
        }
    }
}
</script>

<style lang="scss" scoped>
.customer-list {
    max-height: 300px;
    overflow: visible !important;
}

.customer-container {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    gap: 0.5rem;
    cursor: pointer;
    &:hover { background-color: #f1f1f1; }
    .avatar-container {
        .b-avatar {
            width: 2rem;
            height: 2rem;
        }
    }
    .customer {
        &--name {
            font-size: 1rem;
        }
        &--email {
            font-size: 14px;
            opacity: 0.6;
        }
    }
}

</style>